"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANNOUNCEMENT_ATTACHMENT = 'announcementAttachment';
exports.FILE = 'file';
exports.IMAGE_FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/bmp'];
exports.LOGO_ICON = 'logoIcon';
exports.MEMO_BANNER_IMAGE = 'memoBannerImage';
exports.MENU_BACKGROUND_IMAGE = 'menuBackgroundImage';
exports.PROFILE_IMAGE = 'profileImage';
exports.CUSTOMER_FILE_TYPES = [
    'application/excel',
    'application/json',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/pdf',
    'application/powerpoint',
    'application/xml',
    'application/zip',
    'audio/mp3',
    'audio/mpeg',
    'audio/wav',
    'text/csv',
    'text/plain',
    'video/mpeg',
    'video/ogg',
    'video/webm'
];
exports.FILE_ICON_MAPPINGS = {
    'application/excel': 'xls',
    'application/json': 'js',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xls',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
    'application/pdf': 'pdf',
    'application/powerpoint': '',
    'application/xml': 'xml',
    'application/zip': 'zip',
    'audio/mp3': 'mp3',
    'image/jpeg': 'jpg',
    'audio/mpeg': 'mpg',
    'audio/wav': 'wav',
    'text/csv': 'csv',
    'text/plain': 'txt',
    'video/mpeg': 'mpg'
};
//# sourceMappingURL=file-types.js.map